import { render } from "./TransactionConsultationFee.vue?vue&type=template&id=4d66b1d6&scoped=true"
import script from "./TransactionConsultationFee.vue?vue&type=script&lang=js"
export * from "./TransactionConsultationFee.vue?vue&type=script&lang=js"

import "./TransactionConsultationFee.vue?vue&type=style&index=0&id=4d66b1d6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d66b1d6"]])

export default __exports__